export const API_BASE = import.meta.env.PROD
  ? import.meta.env.VITE_API_URL || window.location.origin
  : 'http://localhost:5000';
